import { apiAddress } from '../ApiPlatform';

export const API_SELECT_ADS_LIST = apiAddress + 'adv/selectAdsList';
export const API_SELECT_ADS_HISTORY_LIST =
  apiAddress + 'adv/selectAdsHistoryList';

export const API_SELECT_ADS_ALL_LIST = apiAddress + 'adv/selectAdsAllList';
